export class QueryStorage {
  constructor(router) {
    this.router = router;
  }

  set(key, value) {
    const { query } = this.router.currentRoute.value;
    query[key] = value;
    this.router.push({ query });
  }
}
